/* ============================================================
   FORMABOX — pricing engine (CAD)
   Single source of truth for the catalogue figures and tax.

   There is deliberately NO average price here, and no multi-course
   discount: every course carries its own price and is charged once.
   The bundle ladder and the all-access tier were removed — the
   ladder was never a real Shopify discount, and all-access was
   never a product anyone could buy.

   SHOPIFY: on the storefront every total comes from Shopify itself.
   Nothing in this file may rewrite a cart total. If a reduction is
   ever introduced it has to exist server-side first (an automatic
   discount or a Function), never only here.
   ============================================================ */
(function () {
  'use strict';

  window.FB = window.FB || {};

  var CONFIG = {
    currency: 'CAD',
    locale: 'en-CA',

    /* Catalog */
    catalogSize: 26,         // number of courses
    catalogValue: 4199.00,   // sum of the individual prices

    /* Canadian tax. In Quebec, QST is computed on the pre-GST amount
       (not compounded). Shopify recalculates the real figures at
       checkout — these are for the on-page estimate only. */
    taxes: {
      QC:      [{ label: 'GST 5%', rate: 0.05 }, { label: 'QST 9.975%', rate: 0.09975 }],
      ON:      [{ label: 'HST 13%', rate: 0.13 }],
      AB:      [{ label: 'GST 5%', rate: 0.05 }],
      BC:      [{ label: 'GST 5%', rate: 0.05 }, { label: 'PST 7%', rate: 0.07 }],
      HORS_CA: []
    },
    defaultRegion: 'QC'
  };

  function money(n) {
    return n.toLocaleString(CONFIG.locale, {
      style: 'currency', currency: CONFIG.currency,
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  /** Full quote for a cart. `prices` = array of unit prices.
      The subtotal is the plain sum: no discount is ever applied. */
  function quote(prices, region) {
    var subtotal = prices.reduce(function (a, b) { return a + b; }, 0);
    var lines = (CONFIG.taxes[region] || CONFIG.taxes[CONFIG.defaultRegion]).map(function (t) {
      return { label: t.label, amount: subtotal * t.rate };
    });
    var tax = lines.reduce(function (a, l) { return a + l.amount; }, 0);
    return {
      count: prices.length,
      list: subtotal,
      subtotal: subtotal,
      taxLines: lines,
      tax: tax,
      total: subtotal + tax
    };
  }

  window.FB.pricing = { config: CONFIG, money: money, quote: quote };

  /* ---------- Figures echoed across the pages ----------------- */
  function fill(sel, value) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
  }
  fill('[data-catalog-size]',  String(CONFIG.catalogSize));
  fill('[data-catalog-value]', money(CONFIG.catalogValue));

  /* Legacy bundle nodes left in the older static prototype pages.
     They are hidden rather than left to render a reduction that no
     longer exists anywhere. */
  ['[data-discount-row]', '[data-pack-chip]', '[data-bundle-nudge]',
   '[data-next-tier]', '[data-bundle-price]', '[data-bundle-saving]',
   '[data-bundle-saving-pct]', '[data-break-even-list]'
  ].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { el.hidden = true; });
  });
  var legacyLadder = document.getElementById('ladder-body');
  if (legacyLadder && legacyLadder.closest('table')) {
    legacyLadder.closest('table').hidden = true;
  }

  /* ---------- Live cart --------------------------------------- */
  /* Opt-in only. On Shopify the cart totals come from Shopify itself and
     must never be overwritten here, so the theme's cart form deliberately
     omits `data-fb-estimate`. */
  var cart = document.querySelector('#checkout-form[data-fb-estimate]');
  if (!cart) return;

  var regionSelect = document.getElementById('region');

  function readCart() {
    return [].map.call(cart.querySelectorAll('.cart-item'), function (li) {
      return parseFloat(li.dataset.price);
    }).filter(function (p) { return !isNaN(p); });
  }

  function render() {
    var prices = readCart();
    var q = quote(prices, regionSelect ? regionSelect.value : CONFIG.defaultRegion);

    var set = function (sel, value) {
      var el = cart.querySelector(sel) || document.querySelector(sel);
      if (el) el.textContent = value;
    };

    set('[data-sum-count]', q.count + (q.count > 1 ? ' courses' : ' course'));
    set('[data-sum-list]', money(q.list));
    set('[data-sum-subtotal]', money(q.subtotal));
    set('[data-sum-total]', money(q.total));

    // Tax lines, rebuilt on every render
    var taxWrap = document.querySelector('[data-tax-lines]');
    if (taxWrap) {
      taxWrap.innerHTML = q.taxLines.length
        ? q.taxLines.map(function (l) {
            return '<div><dt>' + l.label + '</dt><dd>' + money(l.amount) + '</dd></div>';
          }).join('')
        : '<div><dt>Tax</dt><dd>' + money(0) + '</dd></div>';
    }

    // Amount printed on the checkout button
    var pay = cart.querySelector('[data-submit]');
    if (pay) pay.textContent = 'Checkout — ' + money(q.total);
  }

  cart.addEventListener('click', function (e) {
    var remove = e.target.closest('.cart-item__remove');
    if (!remove) return;
    // On Shopify this becomes a POST to /cart/change with quantity 0.
    var item = remove.closest('.cart-item');
    var title = item.querySelector('h3').textContent.trim();
    item.remove();
    render();
    if (window.FB.toast) window.FB.toast('Removed from cart: ' + title);
  });

  if (regionSelect) regionSelect.addEventListener('change', render);
  render();
})();
